import React, { useState, useEffect } from 'react';
import "../CSS/Events.css";
// import Slide from '../Components/Slidtext'
import Footer from "../Components/Footer";

import flowerImg from "../assets/event1.jpg";
import mandapImg from "../assets/LIBRA EVENTS/1461.jpg";
import mandapImg2 from "../assets/LIBRA EVENTS/_SDL4073.jpg";

import flowerImg3 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7601.jpg";
import mandapImg3 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7609.jpg";

import flowerImg4 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-29 at 10.41.35 AM.jpeg";
import mandapImg4 from "../assets/LIBRA EVENTS/_PHP0580.jpg";
import flowerImg5 from "../assets/LIBRA EVENTS/KSH_0083.jpg";
import mandapImg5 from "../assets/LIBRA EVENTS/_PHP0580.jpg";
import flowerImg6 from "../assets/LIBRA EVENTS/KSH_2769.jpg";
import mandapImg6 from "../assets/LIBRA EVENTS/_PHP0580.jpg";




import { FaDotCircle } from "react-icons/fa";
import Header from "../Components/Header";
import bgImage from "../assets/bgImage.png";
// import flower1 from "../assets/event1.jpg";
// import flower2 from "../assets/event2.jpg";
import Contactbar from '../Components/ContactBar';

const features = [
  "Lavish Feel",
  "One Stop Solution",
  "Theme Based Decoration",
  "Best Catering",
  "Selfie/ Group Photo Zone",
  "Parking Facility",
];


const features1 = [
  "Theme Based Decoration",
  "Selfie/ Group Photo Zone",
  "Parking Facility",
  "One Stop Solution",
  "Any Size Pax",
];


const Events = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);

  return (
    <>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section
        className="about-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay container">
          <p className="section-subtitle">ALL YOU NEED TO KNOW</p>

          <h1 className="section-title">
            <span className="highlight">LIBRA</span> EVENTS
          </h1>

          <div className="breadcrumbs mt-3">
          <a href='/' className="home-link">
  <span className="home">Home</span>
</a>

            <span className="divider"> | </span>
            <span className="about">Events</span>
          </div>
        </div>
      </section>

      <div className="libra-welcome animated-section text-center">
  <h2 className="welcome-heading">
    Welcome to <span className="highlight">Libra Events</span>
  </h2>
  <p className="welcome-subtext">
    Where your celebrations come to life with creativity, elegance, and precision. Let us craft unforgettable memories tailored just for you.
  </p>
</div>



      {/* Content Section */}
      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={mandapImg} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={mandapImg} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
              Wedding <span className="text-highlight">Ceremony</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
              Outdoor Venues
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
              Celebrate your special day at Libra Events, the best wedding venue in Vadodara, where luxury meets creativity. We craft dream weddings that blend elegance, tradition, and grandeur — turning every moment into a cherished memory.
            </p>
            <p className="events-content__description text-muted fs-5">
              Our expert team provides theme-based decorations, lavish setups, and professional event planning for all styles of Indian weddings. Whether you prefer a serene outdoor venue or a glamorous indoor setting, Libra ensures a flawless celebration filled with beauty and joy.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
              {features.map((feature, idx) => (
                <div
                  className="col-sm-6 mb-2 d-flex align-items-center"
                  key={idx}
                >
                  <FaDotCircle className="text-pink me-2 fs-5" />
                  <span className="events-content__feature text-dark small-text fw-semibold">
                    {feature}
                  </span>
                </div>
              ))}
            </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20wedding%20event"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>


  </div>
</section>

          </div>
        </div>

      </section>

      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={mandapImg2} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={mandapImg2} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
            Engagement <span className="text-highlight">Ceremony</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
            Outdoor Venues
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
            Celebrate your engagement at Libra Events, the best event venue in Vadodara, designed to make every moment magical. Our expert planners and decorators bring your dream engagement to life with elegant setups, creative themes, and flawless arrangements.
            </p>
            <p className="events-content__description text-muted fs-5">
            We ensure your celebration reflects your personality — stylish, memorable, and picture-perfect. Whether it’s an intimate affair or a grand event, Libra promises beauty, comfort, and perfection in every detail.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
              {features1.map((features1, idx) => (
                <div
                  className="col-sm-6 mb-2 d-flex align-items-center"
                  key={idx}
                >
                  <FaDotCircle className="text-pink me-2 fs-5" />
                  <span className="events-content__feature text-dark small-text fw-semibold">
                    {features1}
                  </span>
                </div>
              ))}
            </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20Engagement%20event"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>


  </div>
</section>

          </div>
        </div>

      </section>

      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={mandapImg3} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={flowerImg3} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
            Corporate <span className="text-highlight">Conferences & Meeting</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
            Exclusive arrangement
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
            Host your next business event with Libra Events, the best corporate event planner in Vadodara. We specialize in creating professional, seamless, and inspiring environments perfect for conferences, seminars, and meetings.
            </p>
            <p className="events-content__description text-muted fs-5">
            Our expert team ensures every detail — from décor and setup to hospitality — reflects your brand’s excellence. Whether it’s an intimate board meeting or a large-scale corporate gathering, we deliver flawless organization and top-tier service every time.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
              {features1.map((features1, idx) => (
                <div
                  className="col-sm-6 mb-2 d-flex align-items-center"
                  key={idx}
                >
                  <FaDotCircle className="text-pink me-2 fs-5" />
                  <span className="events-content__feature text-dark small-text fw-semibold">
                    {features1}
                  </span>
                </div>
              ))}
            </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20Corporate%20Conference%20%26%20Meeting"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>


  </div>
</section>

          </div>
        </div>

      </section>


      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={flowerImg4} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={mandapImg4} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
            Reception <span className="text-highlight">Ceremony</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
            A Grand Celebration of Togetherness
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
            Celebrate love and togetherness with Libra Events, the best reception event planner in Vadodara. We design unforgettable post-wedding celebrations filled with elegance, luxury, and style.
            </p>
            <p className="events-content__description text-muted fs-5">
            From custom theme décor and gourmet catering to live music and grand couple entries, every element is crafted to make your evening truly magical. Our expert team ensures flawless coordination so you can relax and enjoy every beautiful moment.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
        {[
          "Custom Theme Decor",
          "Live Music & DJ Setup",
          "Gourmet Catering Options",
          "Grand Couple Entry",
          "Photobooth Corners",
          "Seamless Coordination",
        ].map((item, i) => (
          <div key={i} className="col-md-6 mb-2 d-flex align-items-center">
            <FaDotCircle className="text-pink me-2 fs-5" />
            <span className="fw-semibold text-dark small-text">{item}</span>
          </div>
        ))}
      </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20Reception%20event"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>

  </div>
</section>

          </div>
        </div>

      </section>


      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={flowerImg5} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={mandapImg5} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
            Sangeet <span className="text-highlight">Ceremony</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
            A Night of Music, Dance & Celebration
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
            Celebrate the rhythm of love and laughter with Libra Events, the best Sangeet event planner in Vadodara. We create unforgettable musical evenings filled with energy, elegance, and emotion — where families and friends come together to dance, sing, and celebrate.
            </p>
            <p className="events-content__description text-muted fs-5">
            From stage and light setups to DJ sound, live performances, and dance choreography, our expert team ensures your Sangeet night is perfectly orchestrated. Whether it’s an intimate gathering or a grand musical fest, Libra Events turns every beat into a beautiful memory.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
        {[
          "Stage & Light Setup",
          "Sound & DJ Arrangements",
          "LED Dance Floor",
          "Customized Couple Entry",
          "Live Performers & Hosts",
          "Dance Choreography Services",
        ].map((item, i) => (
          <div key={i} className="col-md-6 mb-2 d-flex align-items-center">
            <FaDotCircle className="text-pink me-2 fs-5" />
            <span className="fw-semibold text-dark small-text">{item}</span>
          </div>
        ))}
      </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20Sangeet%20event"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>

  </div>
</section>

          </div>
        </div>

      </section>

      <section className="events-content container py-5">
        <div className="row align-items-center g-5">
          {/* Image Column */}
          <div className="col-lg-5 col-md-6 position-relative">
            <img src={flowerImg6} alt="Backdrop" className="img-fluid rounded shadow main-img" />
            {/* <img src={mandapImg6} alt="Mandap" className="img-fluid rounded shadow overlay-img position-absolute" /> */}
          </div>

          {/* Text Column */}
          <div className="col-lg-7 col-md-6">
            <h3 className="events-content__heading fw-bold fs-2">
            Outdoor <span className="text-highlight">Decoration</span>
            </h3>
            <p className="events-content__venue text-pink mb-3 fw-semibold fs-5">
            Nature-Inspired Elegance for Your Big Day
            </p>
            <hr />
            <p className="events-content__description text-muted fs-5">
            Experience the beauty of open skies and natural charm with Libra Events, the best outdoor wedding decorator in Vadodara. We create stunning open-air setups that blend nature with elegance — from floral arches and garden themes to warm fairy lights and elegant canopies.
            </p>
            <p className="events-content__description text-muted fs-5">
            Every design is crafted to reflect romance, creativity, and class, making your celebration truly picturesque. Let Libra Events & Decorators transform your outdoor venue into an enchanting experience you’ll never forget.
            </p>

            {/* Feature List */}
            <div className="row mt-4">
        {[
          "Floral Arches & Aisles",
          "Canopy & Tent Draping",
          "Ambient Fairy Lighting",
          "Rustic Seating Arrangements",
          "Garden-Themed Backdrops",
          "Eco-Friendly Elements",
        ].map((item, i) => (
          <div key={i} className="col-md-6 mb-2 d-flex align-items-center">
            <FaDotCircle className="text-pink me-2 fs-5" />
            <span className="fw-semibold text-dark small-text">{item}</span>
          </div>
        ))}
      </div>
            {/* Bottom Buttons Section */}
<section className="events-buttons-section py-5">
  <div className="container text-center">
  <a href="/gallery" className="me-3 text-decoration-none">
  <button className="btn btn-outline-dark px-4 py-2 fw-semibold mb-3">
    View Gallery
  </button>
</a>

<a
  href="https://wa.me/919909254684?text=I%20want%20to%20book%20a%20Outdoor%20Decoration"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-pink px-4 py-2 fw-semibold mb-3"
>
  Book Now
</a>

  </div>
</section>

          </div>
        </div>

      </section>
      <Contactbar />
<Footer/>
    </>
  );
};

export default Events;
